import { render } from "./HomeView.vue?vue&type=template&id=2c44473b"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2c44473b&lang=css"

import exportComponent from "P:\\GitProjects\\Homepage\\homepage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__